<template>
  <div
    @click="expandEarnings = false"
    class="container text-start"
    v-if="stakersAddress !== null"
  >
    <div class="row">
      <div class="col-xxl-6 mx-auto">
        <div class="card">
          <div class="card-body">
            <div class="col-12 align-items-left">
              <h2>
                <span class="animate-characters">{{ projectname }} NFTs</span>
                &nbsp;

                <a href="#">
                  <i
                    title="Reload numbers"
                    @click="$emit('refreshEvent')"
                    class="ri-refresh-fill"
                  ></i>
                </a>
              </h2>
              <br />
              <h4 class="animate-characters">Staking and Leveling</h4>
              <h5>Balance: {{ stakersRewardTokenBalance }} SVC</h5>
              <br />
              <h5 v-on:refreshEvent="reload">
                Staking power: {{ stakersPower }}🔥
              </h5>
              <br />

              <template v-if="stakersPower > 0">
                <h5>Staked for {{ formatSeconds(stakerStakedForSeconds) }}.</h5>
                <h5>(Harvest and unstake reset the timer.)</h5>
                <br />
                <h5>
                  <strong>Current payout level: {{ stakersPayoutPct }}%</strong>
                </h5>
                <br />
                <template v-if="stakerNextPayoutPctInSeconds > 0">
                  <h5>Next payout level: {{ stakersNextPayoutPct }}%</h5>
                  <h5>
                    (reached in
                    {{ formatSeconds(stakerNextPayoutPctInSeconds) }})
                  </h5>
                </template>
                <h5 v-else>
                  Congratulations! You reached the highest payout level.
                </h5>
              </template>

              <br />

              <h6>Total staked power: {{ totalStakedPower }}🔥</h6>
              <!-- <h6>Base power: {{ baseStakingPower }}🔥</h6> -->
              <h6>
                Total SVC Emission: ~{{
                  Math.round(svcEmissionPerHour * earningsTime * 100) / 100
                }}
                SVC / {{ hoursInWords[earningsTime] }}
              </h6>

              <br />

              <div
                class="settings-menu"
                v-if="svcEmissionPerHour && totalStakedPower && stakersPower"
              >
                <button
                  v-if="expandEarnings === false"
                  class="btn btn-std"
                  @click.stop="expandEarnings = !expandEarnings"
                >
                  Earning ~{{
                    Math.round(stakerEarningRateX1k * earningsTime) / 1000
                  }}
                  SVC / {{ hoursInWords[earningsTime] }} (@100%)
                  <i class="ri-arrow-down-s-line"></i>
                </button>

                <button
                  v-else
                  class="btn btn-outline-std"
                  @click="expandEarnings = !expandEarnings"
                >
                  Earning ~{{
                    Math.round(stakerEarningRateX1k * earningsTime) / 1000
                  }}
                  SVC / {{ hoursInWords[earningsTime] }} (@100%)
                  <i class="ri-arrow-up-s-line"></i>
                </button>

                <ul v-if="expandEarnings">
                  <span
                    v-for="time in Object.keys(hoursInWords)"
                    :key="time"
                    class="dropdown-item"
                    @click="
                      earningsTime = time;
                      expandEarnings = false;
                    "
                    :class="earningsTime === time ? 'current' : ''"
                  >
                    Earning ~{{
                      Math.round(stakerEarningRateX1k * time) / 1000
                    }}
                    SVC / {{ hoursInWords[time] }} (@100%)
                  </span>
                </ul>
              </div>

              <br />

              <div class="settings-menu">
                <button
                  class="btn btn-std"
                  @click="harvest"
                  :disabled="stakingPaused || rewardTokenToHarvest == 0"
                >
                  Harvest
                  {{
                    Math.round(stakersPayoutPct * rewardTokenToHarvest * 10) /
                    1000
                  }}
                  SVC
                </button>

                &nbsp;

                <a
                  target="_blank"
                  href="https://app.mistswap.fi/swap?inputCurrency=BCH&outputCurrency=0xE7B1076d0853a7aAa6FbB477886726ed03C6Fffd"
                  class="btn btn-std"
                >
                  Trade SVC at MistSwap
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="popup" v-if="txInProgress || feedbackMessage != ''">
    <div
      class="popupX"
      @click="
        feedbackMessage = '';
        txInProgress = false;
      "
    >
      x
    </div>
    <h4 v-if="feedbackMessage != ''" class="text-monospace animate-popup">
      {{ feedbackMessage }}
    </h4>
    <br />
    <h5 v-if="txInProgress" class="text-monospace animate-popup">
      Waiting for current transaction to finish...
    </h5>
  </div>
</template>

<script>
import { ethers } from "ethers";
import Reaper from "../../artifacts/contracts/Reaperville.sol/Reaperville.json";
import RewardToken from "../../artifacts/contracts/RewardToken.sol/RewardToken.json";

// let address['svc'] = window.ca['svc'];

export default {
  name: "App",
  props: ["projectname"],
  emits: ["refreshEvent"],

  data() {
    return {
      expandEarnings: false,

      contracts: {},

      provider: null,
      signer: null,

      svcEmissionPerHour: null,

      stakersAddress: null,
      stakerStakedForSeconds: null,
      SECONDS_PER_DAY: 86400, // TODO 86400 = 1 day
      stakersPayoutPct: null,
      stakersNextPayoutPct: null,
      stakerNextPayoutPctInSeconds: null,

      stakersPower: null,
      totalStakedPower: null,
      baseStakingPower: null,
      stakerEarningRateX1k: null,

      earningsTime: 168,
      hoursInWords: {
        1: "hour",
        24: "day",
        168: "week",
        720: "month",
        8760: "year",
      },

      rewardTokenToHarvest: 0,
      stakingPaused: true,
      stakersRewardTokenBalance: 0,

      feedbackMessage: "",
      txInProgress: false,
      lastTimeout: 0,
    };
  },
  methods: {
    collapseMenus: function () {
      this.expandEarnings = false;
    },

    setFeedback: function (_text, _timeOut) {
      let that = this;
      that.feedbackMessage = _text;
      if (that.lastTimeout > 0) {
        clearTimeout(that.lastTimeout);
      }
      if (_timeOut > 0) {
        that.lastTimeout = setTimeout(function () {
          that.feedbackMessage = "";
        }, _timeOut);
      }
    },

    harvest: async function () {
      this.setFeedback("Harvesting your earnings", 0);
      this.txInProgress = true;

      try {
        let tx = await this.contracts["staking"].harvest();
        await tx.wait();

        this.feedbackMessage = "";
      } catch {
        this.setFeedback("The transaction failed :(", 2000);
      }
      this.txInProgress = false;

      this.$emit("refreshEvent");
    },

    approve: async function () {
      this.setFeedback("Approving contract", 2000);
      this.txInProgress = true;

      try {
        let tx = await this.contracts["nft"].setApprovalForAll(
          window.ca["reaper"],
          true
        );
        await tx.wait();

        this.feedbackMessage = "";
      } catch {
        this.setFeedback("The transaction failed :(", 2000);
      }
      this.txInProgress = false;

      this.$emit("refreshEvent");
    },

    formatSeconds: function (seconds) {
      seconds = Number(seconds);
      var d = Math.floor(seconds / (3600 * 24));
      var h = Math.floor((seconds % (3600 * 24)) / 3600);
      var m = Math.floor((seconds % 3600) / 60);
      var s = Math.floor(seconds % 60);

      var dDisplay = d > 0 ? d + " d, " : "";
      var hDisplay = h > 0 ? h + " h, " : "";
      var mDisplay = m > 0 ? m + " min, " : "";
      var sDisplay = s + " sec";
      return dDisplay + hDisplay + mDisplay + sDisplay;
    },

    loadStakerInfo: function () {
      this.contracts["staking"]
        .showStakerInfo(this.stakersAddress)
        .then((stakerInfo) => {
          let stakedForSeconds = stakerInfo[0];
          this.stakerStakedForSeconds = stakedForSeconds;
          if (stakedForSeconds > 30 * this.SECONDS_PER_DAY) {
            this.stakersPayoutPct = 115; // 15% bonus
            this.stakersNextPayoutPct = 115;
            this.stakerNextPayoutPctInSeconds = 0;
          } else if (stakedForSeconds < 19 * this.SECONDS_PER_DAY) {
            let stakedForDays = Math.floor(
              stakedForSeconds / this.SECONDS_PER_DAY
            );
            this.stakersPayoutPct = (stakedForDays + 1) * 5;
            this.stakersNextPayoutPct = this.stakersPayoutPct + 5;
            this.stakerNextPayoutPctInSeconds =
              (stakedForDays + 1) * this.SECONDS_PER_DAY - stakedForSeconds;
          } else {
            this.stakersPayoutPct = 100;
            this.stakersNextPayoutPct = 115;
            this.stakerNextPayoutPctInSeconds =
              30 * this.SECONDS_PER_DAY - stakedForSeconds;
          }

          this.stakersPower = stakerInfo[1];
          this.totalStakedPower = stakerInfo[2];
          this.baseStakingPower = stakerInfo[3];
          this.svcEmissionPerHour = String(
            Math.round(ethers.utils.formatEther(stakerInfo[4]) * 100000) /
              100000
          );
          this.stakerEarningRateX1k =
            ((this.svcEmissionPerHour * this.stakersPower) /
              (this.totalStakedPower - this.baseStakingPower)) *
            1000;
        });
      this.rewardTokenToHarvest = 0;
      this.contracts["staking"]
        .showStakersEarningsUntilLastTimestamp(this.stakersAddress)
        .then((amount) => {
          this.rewardTokenToHarvest +=
            Math.round(ethers.utils.formatEther(amount) * 100000) / 100000;
        });
      this.contracts["staking"]
        .showStakersEarningsAfterLastTimestamp(this.stakersAddress)
        .then((earnings) => {
          this.rewardTokenToHarvest +=
            Math.round(ethers.utils.formatEther(earnings) * 100000) / 100000;
        });
      this.contracts["staking"].isMintPausedStakingPaused().then((result) => {
        this.stakingPaused = result[1];
      });
    },

    getRewardTokenBalance: function () {
      // console.log(this.stakersAddress);
      this.contracts["svc"].balanceOf(this.stakersAddress).then((balance) => {
        this.stakersRewardTokenBalance = String(
          Math.round(ethers.utils.formatEther(balance) * 100000) / 100000
        );
      });
    },

    reload: function () {
      this.getRewardTokenBalance();
      this.loadStakerInfo();
    },

    load: function () {
      this.signer.getAddress().then((userAddress) => {
        // console.log(this.stakersAddress);
        this.stakersAddress = userAddress;
        // console.log(this.stakersAddress);
        this.loadStakerInfo();
        this.getRewardTokenBalance();
      });
    },
  },

  mounted: function () {
    this.provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    this.provider
      .send("eth_requestAccounts", [])
      .then(() => {
        this.signer = this.provider.getSigner();
        this.contracts["svc"] = new ethers.Contract(
          window.ca["svc"],
          RewardToken.abi,
          this.signer
        );
        this.contracts["staking"] = new ethers.Contract(
          window.ca["reaper"],
          Reaper.abi,
          this.signer
        );
      })
      .then(() => {
        this.load();
      });
  },
};
</script>
